import { Logo } from '@lemonade-hq/nuis';
import type { FC } from 'react';
import { PartnerName } from '../../../../definitions';
import type { SupportedLogoProps } from './AnimateLogoPair';
import CardifLogoPacked from './assets/cardif-logo-packed.svg';
import RevolutLogoPacked from './assets/revolut-logo.svg';

export const PARTNER_NAME_TO_LOGO: Record<PartnerName, [string, FC<SupportedLogoProps>]> = {
  [PartnerName.Cardif]: [CardifLogoPacked, Logo],
  [PartnerName.Revolut]: [RevolutLogoPacked, Logo],
};
